import { axiosApi } from "../../../../../../../api/dbAxios";

export const fetchTeamUsers = async (regulatorCode: string | undefined) => {
  const test_email = "ykozak@deloittece.com";
  try {
    const isLocalhost =
      typeof window !== "undefined" && window.location.hostname === "localhost";
    const params: Record<string, string> = {};
    if (regulatorCode) params.code = regulatorCode;
    if (isLocalhost) params.test_email = test_email;

    const response = await axiosApi.get(`/users/`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Team Users", error);
    return {};
  }
};
